import { noop } from "lodash";
import { useQuery } from "react-query";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { selectActions, useChatRoomStoreChatRoom } from "../chatsV2/store";
import { useChatStore } from "../chatsV2/store/useChatStore";

export const embeddableChatApiQueryKey = (chatRoomUuid?: string | null) =>
  `embeddable-chat-room-${chatRoomUuid}`;

export const useEmbeddableChatApi: any = (chatRoomUuid?: string | null) => {
  const { updateChatRoom } = useChatStore(selectActions);
  const chatRoomStoreState = useChatRoomStoreChatRoom();

  const {
    isLoading,
    refetch: refetchChatRoom,
    data: { chat_room: chatRoom } = {},
  } = useQuery({
    queryKey: embeddableChatApiQueryKey(chatRoomUuid),
    queryFn: () =>
      reactQueryGet(internalApi.chatRooms.show({ uuid: chatRoomUuid })),
    enabled: Boolean(chatRoomUuid) && chatRoomUuid !== "new",
    refetchOnWindowFocus: false,
    onSuccess: ({ chat_room }) => {
      if (chat_room) {
        updateChatRoom(chat_room);
      }
    },
  });

  const onEventReceive = (eventData: any) => {
    if (eventData.event === "chatRoomUpdated") {
      const { chat_room: chatRoomData } = eventData;
      updateChatRoom({
        ...chatRoomData,
        pinned_message: chatRoomData.pinned_message,
      });
    }
    if (
      eventData.event === "updatedMessage" &&
      chatRoomStoreState?.pinned_message?.id === eventData.json_message.id
    ) {
      updateChatRoom({
        uuid: chatRoom?.uuid,
        pinned_message: eventData.json_message,
      });
    }
    if (
      eventData.event === "deletedMessage" &&
      chatRoomStoreState?.pinned_message?.id === eventData.id
    ) {
      updateChatRoom({
        uuid: chatRoom?.uuid,
        pinned_message: null,
      });
    }
  };

  return {
    isLoading,
    chatRoom,
    refetchChatRoom: chatRoomUuid ? refetchChatRoom : noop,
    onEventReceive,
  };
};
